import styled from '@emotion/styled';
import { Button, Typography } from '@material-ui/core';
import { MouseEvent, FC } from 'react';
import { Pathname } from 'history';
import _Logo from '../component/primitive/KaizenPlatformLogo';
import { SPACING_UNIT, SPACING_REGULAR } from '../constant/spacing';
import { subText } from '../constant/color';
import { gridLayoutContainer, gridLayoutItem } from '../styleUtility/gridLayout';

interface Props {
  error: Error;
  solveTo: string;
  onClickBackButton: (e: MouseEvent<HTMLElement>, solveTo: string) => void;
  className?: string;
  pathname: Pathname;
}

const FatalErrorScreen: FC<Props> = ({ error, solveTo, onClickBackButton, className, pathname }) => {
  const viewItemProperties =
    // Setting at 'root path' and 'other page'
    pathname === '/' || pathname === '/projects'
      ? {
          subMessage: `RootError`,
          backButtonHandler: () => location.reload(),
          backButtonText: 'root.for_fatal_error.reload',
        }
      : {
          subMessage: `${error.message}.tips`,
          backButtonHandler: (e: MouseEvent<HTMLElement>) => onClickBackButton(e, solveTo),
          backButtonText: 'root.for_fatal_error.back',
        };

  return (
    <Root className={className}>
      <Logo />
      <Title variant="h3" gutterBottom>
        {error.message}
      </Title>

      {viewItemProperties.subMessage ? <Message variant="subtitle1">{viewItemProperties.subMessage}</Message> : null}

      <BackButton variant="contained" color="primary" onClick={viewItemProperties.backButtonHandler}>
        戻る
      </BackButton>
    </Root>
  );
};

const Root = styled('div')(
  gridLayoutContainer({
    columns: ['auto'],
    rows: ['auto', 'auto', 'auto', 'auto'],
    areas: [['logo'], ['title'], ['errorMessage'], ['button']],
    alignContent: 'center',
    justifyItems: 'center',
    alignItems: 'flex-start',
  }),
  {
    marginTop: `-${SPACING_REGULAR}px`,
    marginRight: 'auto',
    marginLeft: 'auto',
  },
);

const Logo = styled(_Logo)(gridLayoutItem('logo'), {
  width: 305,
  marginBottom: SPACING_UNIT * 8,
});

const Title = styled(Typography)(gridLayoutItem('title'), {
  marginBottom: SPACING_UNIT * 4,
  fontWeight: 500,
  maxWidth: 720,
});

const Message = styled(Typography)(gridLayoutItem('errorMessage'), {
  marginBottom: SPACING_UNIT,
  maxWidth: 720,
  color: subText,
});

const BackButton = styled(Button)(gridLayoutItem('button'), {
  marginTop: SPACING_UNIT * 2,
  minWidth: '150px',
});

export default FatalErrorScreen;
